<template>
  <section
    class="hero-section"
    :style="{ backgroundImage: `url(${backgroundImage})` }"
  >
    <div class="hero-overlay"></div>
    <div class="container hero-content">
      <h1>{{ $t("hero.title") }}</h1>
      <p>{{ $t("hero.subtitle") }}</p>
      <button class="cta-button" @click="navigateToAboutUs">
        {{ $t("hero.cta") }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      // Replace with your actual hero image URL or use a local image
      // For local: backgroundImage: require('@/assets/hero-image.jpg')
      backgroundImage:
        "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&fm=jpg&ixlib=rb-4.1.0&q=80&w=1600",
    };
  },
  methods: {
    navigateToAboutUs() {
      this.$router.push("/about");
    },
  },
};
</script>

<style scoped>
.hero-section {
  height: 80vh; /* Increased height for better visual impact */
  min-height: 600px;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  text-align: center;
  padding: 0 20px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0.7) 100%
  );
}

.container.hero-content {
  position: relative; /* To sit on top of overlay */
  z-index: 1;
  max-width: 900px; /* Slightly wider */
}

h1 {
  font-size: 3em; /* Larger title */
  margin-bottom: 24px;
  font-weight: 700;
  line-height: 1.2;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3); /* Added text shadow */
}

p {
  font-size: 1.1em; /* Slightly larger */
  margin-bottom: 40px;
  line-height: 1.6;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.cta-button {
  background-color: #007bff; /* UAMAX blue, or your primary brand color */
  color: white;
  padding: 16px 40px; /* Slightly larger padding */
  border: none;
  border-radius: 30px; /* Rounded pill shape */
  font-size: 1.15em;
  font-weight: 600; /* Slightly bolder */
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase; /* Optional: for a more "button" feel */
  letter-spacing: 1px; /* Optional */
  box-shadow: 0 4px 15px rgba(0, 123, 255, 0.4);
}

.cta-button:hover {
  background-color: #0056b3; /* Darker shade on hover */
  transform: translateY(-3px); /* Slight lift on hover */
  box-shadow: 0 6px 20px rgba(0, 123, 255, 0.6);
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .hero-section {
    height: 60vh; /* Adjust height for smaller screens */
  }
  h1 {
    font-size: 2.2em;
  }
  p {
    font-size: 1.1em;
  }
  .cta-button {
    padding: 12px 28px;
    font-size: 1em;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.8em;
  }
  p {
    font-size: 1em;
  }
  .cta-button {
    padding: 10px 20px;
  }
}
</style>
